<template>
  <div class="line">
    <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
    <div id="line"
         ref="line"
         style="float:left;width:100%;height: 250px"></div>
  </div>
</template>
 
<script>
var echarts = require('echarts');

export default {
  props: ['dataList2'],
  data () {
    return {
      // 数据
      dom: null,
    }
  },
  computed: {
    options () {
      let that = this;
      let option = {
        grid: {
          x: 55,
          y: 45,
          x2: 5,
          y2: 20,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            textStyle: {
              color: '#979DAE',//坐标值得具体的颜色
            }
          },
          axisLine: {  //x轴线
            show: true,
            lineStyle: {
              color: '#484857'
            }
          },
          splitLine: {
            show: true,   //X网格线
            lineStyle: {   //x网格线
              color: '#484857'
            }
          },
          data: ['非常低', '较低', '平均水平', '较高']
        },
        yAxis: {
          splitLine: {
            show: true,     //y网格线
            lineStyle: {
              color: '#484857'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#484857'  //Y轴颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#979DAE',//坐标值得具体的颜色
            }
          },
          type: 'log',
        },
        series: [{
          itemStyle: {
            normal: {
              color: '#6DEAFF',
              lineStyle: {        // 系列级个性化折线样式  
                width: 1,
                type: 'solid',
                color: "#6DEAFF"
              },
            },
            emphasis: {
              color: '#6DEAFF',
              lineStyle: {        // 系列级个性化折线样式  
                width: 1,
                type: 'solid',
                color: "#6DEAFF" //折线的颜色
              }
            }
          },//线条样式  
          symbolSize: 5, //折线点的大小
          areaStyle: {
            normal: {   //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0, color: '#378795' // 0% 处的颜色
              }, {
                offset: 1, color: '#252631' // 100% 处的颜色
              }]
              ),  //背景渐变色 
              lineStyle: {        // 系列级个性化折线样式  
                width: 1,
                type: 'solid',
                color: "#29C8B7"
              },
            }
          },
          data: [3000, 3500, 5000, 20000, 50000],
          type: 'line'
        }]
      }
      return option;

    }
  },
  mounted () {
    this.initData();
    window.addEventListener('resize', this.options)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.options)
  },
  watch: {
    dataList2: {
      handler (newVal, oldVal) {
        this.initData();
      },
      deep: true
    }
  },
  methods: {
    resize () {
      this.dom.resize();
    },
    //初始化数据
    initData () {
      var myChart = echarts.init(document.getElementById('line'));
      // this.options.series[0].data = this.dataList2;
      // 绘制图表
      myChart.setOption(this.options);
    },
  }
}
</script>